// Sample `count` evenly spaced key-frames from a <video> element as JPEG data URLs.
export async function extractFrames(video, count = 8, width = 640) {
  const dur = video.duration;
  if (!dur || !isFinite(dur) || !video.videoWidth) return [];
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = Math.round((width * video.videoHeight) / video.videoWidth);
  const ctx = canvas.getContext("2d");
  const wasTime = video.currentTime;
  video.pause();
  const frames = [];
  for (let i = 0; i < count; i++) {
    const t = Math.min(dur - 0.05, (dur * (i + 0.5)) / count);
    await seekTo(video, t);
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    frames.push(canvas.toDataURL("image/jpeg", 0.72));
  }
  await seekTo(video, wasTime || 0);
  return frames;
}

const seekTo = (video, t) =>
  new Promise((resolve) => {
    const done = () => { video.removeEventListener("seeked", done); clearTimeout(timer); resolve(); };
    const timer = setTimeout(done, 2500);
    video.addEventListener("seeked", done);
    video.currentTime = t;
  });
